/* import __COLOCATED_TEMPLATE__ from './submit-success-banner.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import type Session from 'embercom/services/session';
import type Snackbar from 'embercom/services/snackbar';
import { type Notification } from 'embercom/services/snackbar';

interface Signature {
  Args: {
    notification: Notification;
  };
}

export default class SubmitSuccessBanner extends Component<Signature> {
  @service declare router: RouterService;
  @service declare session: Session;
  @service declare snackbar: Snackbar;

  @action viewConversation() {
    this.snackbar.clearNotification(this.args.notification);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::HitlCard::SubmitSuccessBanner': typeof SubmitSuccessBanner;
    'inbox2/composer/hitl-card/submit-success-banner': typeof SubmitSuccessBanner;
  }
}
